import React from "react";

import "./Images.scss";
import { storeColors } from "../../../store/reducers/reports";

const StoreImages = (props) => {
  const { stores } = props;
  return (
    <div className="reports-images">
      {stores.map((s, index) => (
        <div key={index} className="report-image">
          <div className="report-image-header">
            <div
              className="report-image-dot"
              style={{ backgroundColor: storeColors[index] }}
            />
            <div className="report-image-title">{s.NAME}</div>
          </div>
          <img
            src={`./data/stores/${s.ID}.jpg`}
            width="200"
            height="150"
            alt={s.NAME}
          />
        </div>
      ))}
    </div>
  );
};

export default React.memo(StoreImages);
